document.documentElement.classList.remove('no-js');

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-quantity-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.closest('[data-quantity]')?.querySelector('input');
      if (!input) return;
      const step = Number(input.step || 1);
      const current = Number(input.value || 1);
      const direction = button.dataset.quantityButton;
      const nextValue = direction === 'plus' ? current + step : Math.max(step, current - step);
      input.value = nextValue;
    });
  });
});
